import React from 'react';
import PropTypes from 'prop-types';
import './SKU.css';

export const SKUVariants = {
    GOLD: "gold",
    RED: "red",
    GREEN: "green",
    BLUE: "blue",
    WHITE: "white",
    BLACK: "black",
    LIGHT_GRAY: "light-gray",
    GRAY: "gray",
}

const SKU = (props) => {
    const { variant, className } = props;
    let bg = "sku";

    switch (variant) {
        case SKUVariants.GOLD:
            bg = `${bg} sku-bg-gold`;
            break;
        case SKUVariants.RED:
            bg = `${bg} sku-bg-red`;
            break;
        case SKUVariants.GREEN:
            bg = `${bg} sku-bg-green`;
            break;
        case SKUVariants.BLUE:
            bg = `${bg} sku-bg-blue`;
            break;
        case SKUVariants.WHITE:
            bg = `${bg} sku-bg-white`;
            break;
        case SKUVariants.BLACK:
            bg = `${bg} sku-bg-black`;
            break;
        case SKUVariants.LIGHT_GRAY:
            bg = `${bg} sku-bg-light-gray`;
            break;
        case SKUVariants.GRAY:
            bg = `${bg} sku-bg-gray`;
            break;
        default:
            break;
    }
    return (
        <span className={`${bg} ${className}`}>{props.children}</span>
    );
}

SKU.defaultProps = {
    variant: "white",
}

SKU.propTypes = {
    variant: PropTypes.string,
    className: PropTypes.string,
}

export default SKU;